import * as urls from './urls';

const constants = {
  urls,
  IS_MOCK_ON: DEPLOY_ENV !== 'master' && window.location.href.indexOf('__MOCK__') > -1
};

if (window.location.search.indexOf('__LOG_CONSTANTS__') > -1) {
  //console.log(constants);
}

//是否正式环境
export const isProduction = DEPLOY_ENV === 'master';
// 是否开启灰度环境配置
export const ENABLE_STAGING_SETTING = DEPLOY_ENV === 'master' && false;

export default constants;
